export const setFirmwareData = (el = {}) => {
  return {
    createdAt: el?.CreatedAt ?? null,
    updatedAt: el?.UpdatedAt ?? null,
    deletedAt: el?.DeletedAt ?? null,
    id: el?.id ?? el?.ID ?? null,
    link: el?.file_link || "",
    version: el?.version || "",
    hash: el?.hash || "",
    latest: el?.latest || false,
  };
};